import(/* webpackMode: "eager" */ "C:\\Users\\Abcom\\Documents\\salman\\edviseme\\edviseme_website_new\\src\\app\\page.jsx");
